import { BloodIndentReceiveDetails } from './BloodIndentReceiveDetails';
import { Parameter } from './../../../../@core/interfaces/common/parameter';
import { Observable } from 'rxjs';

export interface BloodIndentReceiveHeaderParameter extends Parameter {
  searchTerm: number;
  orderBy: string;
}

export interface BloodIndentReceiveHeader {
  blGRNDate:any;
  blIndentFrom?: string;
  blRegid: string;
  blGRNDoneBy:string;
  blReceivedBy: string;
  blSenderTenantId: string;
  blSenderBranchId: string;
  blReceiverTenantId: string;
  blReceiverBranchId: string;
  blInternalDepartmentId: number;
  createdDate: string;
  createdBy:any;
  updatedBy: any;
  updatedDate: any;
  tenantId: string;
  branchId: string;
  bloodIndentGRNDetDto: BloodIndentReceiveDetails[];
}

export abstract class BloodIndentReceiveHeaderData {
  abstract list(url: string): Observable<any[]>;
  abstract getById(url: string): Observable<any>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}

